export const strings = {
  menuItems: {
    profile: 'Profile',
    diagnostics: 'Diagnostics',
    reportBug: 'Report a Bug',
    signOut: 'Sign Out',
    refreshUserStatus: 'Refresh User Status',
  },
  refreshConfirmationModal: {
    title: 'Refresh user status?',
    body: 'If you are on a call, then refreshing user status will end that call. Are you sure you want to continue?',
    primaryText: 'Yes, refresh user status',
    secondaryText: 'Cancel',
  },
} as const;
